import { createStyles } from '@material-ui/core';

import { KomodoTheme } from '~/theme/komodo-mui-theme';
import { tableStyles } from '~/theme/table-styles';

export default (theme: KomodoTheme) => {
  const { cell } = tableStyles(theme);
  return createStyles({
    cell,
    emptyHeaderCell: {
      minWidth: 66,
      backgroundColor: theme.palette.ds.background.primary,
      position: 'sticky',
      top: 0,
      zIndex: 10,
    },
    headerCell: {
      maxWidth: 'unset',
      textAlign: 'left',
      height: 'auto',
      borderBottom: theme.border.line,
      position: 'sticky',
      top: 0,
      zIndex: 10,
      background: theme.palette.ds.background.primary,
      '&:focus-visible': {
        outline: `2px solid ${theme.palette.ds.selection['focus-outline']}`,
        outlineOffset: -2,
      },
    },
    headerCellCompact: {
      ...theme.typography.webTableHeader,
      padding: '4px 8px',
    },
    headerCellStandard: {
      ...theme.typography.webButton,
      padding: 8,
    },
    iconSortArrow: {
      fontSize: theme.typography.webTableText.lineHeight,
      fill: theme.palette.disabledGrey,
    },
    iconSortArrowActive: {
      fill: theme.palette.primaryBlue,
    },
    iconSortArrowFlipped: {
      transform: 'rotate(180deg)',
    },
  });
};
